<template>
  <!-- modal -->
  <div class="dimed">
    <div class="layer">
      <div class="layer__header">
        <div class="lyr-title">{{ $t('Modal.EmoneyPay.msg1') }}</div>
        <div class="ft-point">{{ $t('Modal.EmoneyPay.msg2') }}</div>
      </div>
      <div class="layer__body" @mouseup="this.setPay()">
        <img src="@/assets/images/user/artwork_popup_emoney_3d_jp.gif" alt="" class="" style="height: 370px" />
      </div>
      <div class="layer__button">
        <button @mouseup="cancelPayment()" class="btn btn--line btn--xlg btn-anim">{{ $t('Modal.EmoneyPay.msg3') }}</button>
      </div>
    </div>
    <!-- //modal -->
  </div>
</template>
<script>
import axios from 'axios';

export default {
  name: 'emoneyPay',
  data() {
    return {
      darkModeYn: this.$store.getters.getDarkModeYn,
      cancelYn: false,
    };
  },
  mounted() {
  },
  props: {
    totalUprc: Number,
  },
  methods: {
    async endTest() {
      let url = '/api/payment/endTest';
      let response = await axios.post(url);
    },
    setPay() {
      this.endTest();
      let tranObj = {
        tranNo: '001',
        orderNo: '001',
        payType: 'EMONEY',
        totalUprc: this.totalUprc,
      };
      this.$emit('setPayComplete', tranObj);
    },
    async cancelPayment() {
      if (!this.cancelYn) {
        let url = '/api/payment/cancel';
        let response = await axios.post(url, {payType: 'EMONEY'});
        this.socket.off('TRAN');
        this.cancelYn = true;
        this.$store.dispatch('startIdle');
        this.$logInfo(`Emoney Cancel Payment`);
        this.$emit('closeEmoneyPay');
      }
    },
  },
  computed: {
    darkMode: function () {
      return this.$store.getters.getDarkModeYn;
    },
  },
  watch: {
    darkMode() {
      this.darkModeYn = this.darkModeYn ? false : true;

      this.$changeDarkMode(this.darkModeYn);
    },
  },
  components: {},
};
</script>

<style src="@/assets/css/user/common.css" scoped></style>
<style src="@/assets/css/user/pages/menu.css" scoped></style>
<style src="@/assets/css/user/pages/touchbox.css" scoped></style>
<style src="@/assets/css/user/dark/common-dark.css" scoped></style>
<style src="@/assets/css/user/dark/menu-dark.css" scoped></style>
<style src="@/assets/css/user/dark/touchbox-dark.css" scoped></style>
<style scoped></style>
